<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.glossaryLabel }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <table
          mat-table
          [dataSource]="dataSource"
          class="sggs-table mat-elevation-z0 demo-table"
        >
          <ng-container
            *ngFor="let column of columns; let i = index"
            [matColumnDef]="column.columnDef"
          >
            <th
              [class.firstHeading]="i === 0"
              mat-header-cell
              *matHeaderCellDef
              class="sggs-table-row-outline sggs-table-header"
            >
              {{ column.header }}
            </th>
            <td mat-cell *matCellDef="let row" class="sggs-table-row-outline">
              {{ column.cell(row) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
